<template>
    <v-container>
		<div style="background-color:maroon;color:white">
			Schedule
		</div>
        <scheduleDetails @selectedDate="dateRangeChange" :eventSettings="eventSettings"></scheduleDetails>
    </v-container>
</template>

<script>
	import scheduleDetails from '@/components/scheduleDetails.vue'
	import services from '@/services/services.js'

    export default {
    name: 'schedule',
	components: {
		scheduleDetails,
	},
    data: () => ({
        eventSettings: {
				dataSource: [
						{
							Id: 1,
							Subject: 'puppy1: Corolla',
							StartTime: new Date(2022, 9, 19, 8, 0),
							EndTime: new Date(2022, 9, 19, 16, 0),
							TypeId: 1
						},
						{
							Id: 2,
							Subject: 'Residential',
							StartTime: new Date(2022, 9, 13, 8, 0),
							EndTime: new Date(2022, 9, 13, 11, 30),
							TypeId: 2,
						},
						{
							Id: 3,
							Subject: 'Commercial',
							StartTime: new Date(2022, 9, 14, 8, 0),
							EndTime: new Date(2022, 9, 14, 11, 30),
							TypeId: 3,
						},
						{
							Id: 4,
							Subject: 'Automotive',
							StartTime: new Date(2022, 9, 13, 8, 0),
							EndTime: new Date(2022, 9, 13, 16, 0),
							TypeId: 1
						},]
			},
		newEventData:[],
		typeID:1,
    }),
	methods: {
		dateRangeChange(value)
		{
			this.lastValue=value;
			value.token=this.$store.state.token;
			services.getSchedules(value).then(response=>{
					if (response.data.token) 
						this.$store.commit('setToken',response.data.token);
					var newSchedule=[];
					if (response.data.data)
					{
						var id=1;
						response.data.data.forEach(function(item)
						{
							var newItem={};
							newItem.EndTime=new Date(item.EndTime);
							newItem.Id=id++;
							newItem.StartTime=new Date(item.StartTime);
							newItem.Subject=item.Subject;
							newItem.TypeId=item.TypeId;
							newSchedule.push(newItem);
						});
						this.updateSchedule(newSchedule);
					}
					
				}).catch(error=> { console.log(error)})
        },
		updateSchedule(newSchedule)
		{
			this.eventSettings.dataSource=[];
			this.eventSettings.dataSource=newSchedule;
			var scheduleObj=document.getElementById('schedule').ej2_instances[0];
			scheduleObj.eventSettings.dataSource = this.eventSettings.dataSource;
			scheduleObj.refreshEvents();
		},
	},	
	computed: {
	},
	created() {
	},
  }
</script>
<style>
</style>